module.exports = __webpack_public_path__ + "media/home/EmbedForm-cd958fdb.png";